import ProductDto from "../Common/dtos/ProductDto";
import { QueryOptions } from "../Common/useQuery";
import useUserOrEmployeeQuery from "../Common/useUserOrEmployeeQuery";
import { useUserOrKaEmployee } from "../UserAccess/useUserOrKaEmployee";

const useGetProducts = (options?: QueryOptions<ProductDto[]>) => {
  const { selectedBusiness } = useUserOrKaEmployee();

  return useUserOrEmployeeQuery<ProductDto[]>(
    { path: `/api/businesses/${selectedBusiness?.id}/products` },
    options);
}

export default useGetProducts;
